import React, { useEffect } from "react";
import { setCurrentChat } from "../../Reducers/actions/chatActions";
import { useDispatch, useSelector } from "react-redux";
// import CircleNone from "../../components/CircleNone/CircleNone";
import Icon from "../../components/Icon/Icon";
import "./Conversations.scss";
import Chat from "../../components/Chat/Chat";
import { useNavigate } from "react-router-dom";
import ConversationItemSkeleton from "../../components/Chat/ConversationItemSkeleton";
import { setTopNavbar } from "../../Reducers/actions/navbarActions";

// Import real-time hooks
import useConversationsPolling from "../../hooks/useConversationsPolling";

const Conversations = () => {
    const navigate = useNavigate()

    const dispatch = useDispatch();
    const chats = useSelector((state) => state.chat.chats);
    const loading = useSelector((state) => state.chat.loading);

    // Initialize conversations polling for real-time updates
    const conversationsPolling = useConversationsPolling();

    useEffect(() => {
        dispatch(setTopNavbar({
            title: "Conversations",
            showBack: true,
        }))
        // Initial getChats call is now handled by useConversationsPolling hook
    }, []);

    const handleClick = (chat) => {

        dispatch(setCurrentChat(chat));
        navigate(`/chat?chat_id=${chat.id}`);
    }

    return (
        (loading || chats === null) ? (
            <div className="chats-container" role="status" aria-label="Loading conversations">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                    <ConversationItemSkeleton key={i} />
                ))}
            </div>
        ) : <div className="chats-container">
            {chats?.length > 0 ? [...chats]
                .sort((a, b) => {
                    const aLastMessage = a.messages?.[a.messages.length - 1];
                    const bLastMessage = b.messages?.[b.messages.length - 1];
                    
                    const aTimestamp = aLastMessage?.created_at || a.created_at;
                    const bTimestamp = bLastMessage?.created_at || b.created_at;
                    
                    return new Date(bTimestamp) - new Date(aTimestamp);
                })
                .map((chat) => (
                <Chat key={chat.id} chat={chat} handleClick={handleClick} />
            )) : <div className="no-chats-container d-flex f-column aic jcc">
                    <Icon alias="conversations" color="#FF3232" width={190} height={171} />
                                        <p className="no-chats-message">Let's talk to someone first</p>
            </div>}
        </div>
    );
};

export default Conversations;
